module.exports = __webpack_public_path__ + "static/media/HoloConnect_1.4f5fdbbc.png";